import { Component, Input, OnInit } from '@angular/core';
import SwiperCore, {
  SwiperOptions,
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper';
import { createDeptUrl } from 'src/app/helpers/url-helper';
import { environment } from 'src/environments/environment.prod';
import { Banner } from '../../../models/banner.model';
import { OpenExternalUrlDialogComponent } from '../../utility/open-external-url-dialog/open-external-url-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { generateSlug } from 'src/app/helpers/slug-helper';

SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: 'app-banner-section',
  templateUrl: './banner-section.component.html',
  styleUrls: ['./banner-section.component.scss'],
})
export class BannerSectionComponent implements OnInit {
  bannerSliderConfig: SwiperOptions = {
    slidesPerView: 1,
    lazy: true,
    spaceBetween: 50,
    navigation: true,
    loop: true,
    pagination: { clickable: true },
    autoplay: {
      delay: 2000,
    },
    mousewheel: true,
    speed: 800,
    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
    },
  };

  @Input() isLoading!: boolean;
  @Input() banners!: Banner[];

  constructor(private matDialog: MatDialog, private router:Router) {}

  ngOnInit() {}

  get isShowBanners() {
    return !this.isLoading && this.banners?.length;
  }

  openBannerUrl(actionType: string, actionUrl: string) {
    let redirectUrl = '';

    switch (actionType?.toLowerCase()) {
      case 'service': {
        if (actionUrl?.indexOf('https://') !== 0) {
          // TODO: Open chatbot here
          return;
        }

        if(actionUrl?.includes('/dept/')) {
          const urlInParts = actionUrl?.split('|'); 
          if(urlInParts?.length > 1) {
            const deptName = urlInParts[1];
            this.router.navigateByUrl(`/department/${generateSlug(deptName)}`);
            return;
          }
        }

        const actionUrlSplit = actionUrl.split('|');
        let deptUrlS = actionUrlSplit[0];
        if (!deptUrlS.endsWith('/')) {
          deptUrlS += '/';
        }
        const deptUrl = createDeptUrl(deptUrlS);
        const deptName = actionUrlSplit[1];
        const deptId = actionUrlSplit[2];

        const redirectParams = `department?url=${deptUrl}&dept_id=${deptId}&dept_name=${deptName}`;

        redirectUrl = `${
          environment.deployUrl
        }/web_new/login?redirect_to=${encodeURIComponent(redirectParams)}`;

        break;
      }
      case 'browser': {
        // redirectUrl = actionUrl;
        this.matDialog.open(OpenExternalUrlDialogComponent, {
          data: { url: actionUrl },
        });
        break;
      }
    }

    redirectUrl && window.open(redirectUrl, '_blank');
  }
}
